var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa5c66;}.cls-2{fill:#e93d5b;}.cls-3{fill:#face53;}.cls-4{fill:#fabb53;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Winner"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.576,11.543,31,17H18.938l-4.55-5.472A2,2,0,0,1,14,10.345V0H36V10.311A2,2,0,0,1,35.576,11.543Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 17,
    width: 10,
    x: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.062,21H19a3,3,0,0,1,0-6H31a2.916,2.916,0,0,1,3,3A2.882,2.882,0,0,1,31.062,21ZM19.008,17a1,1,0,1,0,0,2h12.05A.885.885,0,0,0,32,18a.919.919,0,0,0-1.012-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.5,19c-.169,0-.333.02-.5.025S24.669,19,24.5,19a14.5,14.5,0,0,0,0,29c.169,0,.333-.02.5-.025s.331.025.5.025a14.5,14.5,0,0,0,0-29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 24.5,
    cy: 33.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 24.5,
    cy: 33.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25,41a1,1,0,0,1-1-1V29.441l-2.288,2.323a1,1,0,1,1-1.424-1.4l4-4.063A1,1,0,0,1,26,27V40A1,1,0,0,1,25,41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopScore);
export default __webpack_public_path__ + "static/media/top_score.e6bdb4d447e1468dead61355dcd07c89.svg";
export { ForwardRef as ReactComponent };